import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Col, Container, Row } from 'react-bootstrap';
import BannerImg from '../../assets/backgrounds/patients/banner.webp';
import BannerMobile from '../../assets/backgrounds/patients/bannermobile.webp';
import { useTranslation } from 'react-i18next';

const BannerBackground = styled.div`
  width: 100%;
  height: 460px;
  box-shadow: rgba(10, 10, 10, 0.4) 0px 4px 10px;
  overflow: hidden;
  margin-top: -70px;
  background: url("https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2FaxionaHome%2Fimg%2Fbg%20banner%20pac%201.png?alt=media&token=308fc700-cf98-43f0-8ead-048e6e774988") center no-repeat;
  @media only screen and (max-width: 768px) {
    background: url("https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fbanners%2Fbg%20banner%20pac%201%20mb.png?alt=media&token=10038fef-591a-4d42-9d7d-49bfbfba7f24" center no-repeat);
    height: 400px;
    margin-top: 0px;
  }
  .row {
    width: 100%;
    align-items: center;
  }
  #col-img {
    height: 535px;
    position: relative;
    @media only screen and (max-width: 768px) {
      height: 320px;
    }
    img {
      width: 940px;
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translate(-50%, 0);
      @media only screen and (max-width: 992px) {
        width: 600px;
        bottom: 75px;
      }
      @media only screen and (max-width: 768px) {
        transform: translate(-50%, 9%);
        width: 547px;
        bottom: 80px;
      }
      @media only screen and (max-width: 405px) {
        transform: translate(-50%, 3%);
      }
    }
  }
`;

const BannerContent = styled(Col)`
  height: 100%;
  display: flex;
  align-items: center;
  @media only screen and (max-width: 768px){
    padding: 10% 10% 0 10%;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
`;

const BannerDesc = styled.p`
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 28.5px;
  line-height: 120%;
  color: #F2F7F7;
  margin: auto 0;
  text-align: left;
  max-width: 550px;
  @media only screen and (max-width: 1200px){
    font-size: 30px;
  }
  @media only screen and (max-width: 992px){
    font-size: 25px;
  }
  @media only screen and (max-width: 768px){
    font-size: 20px;
    max-width: 100%;
    line-height: 135.5%;
    //margin-top: 23px;
  }
  @media only screen and (max-width: 668px){
    //margin-top: 43px;
  }
`;

export const Banner = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const {t} = useTranslation('global');

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return(
    <BannerBackground>
      <Container>
        <Row>
          <BannerContent xs={12} sm={12} md={6} lg={{span: 5, offset: 1}}data-aos='fade-up' >
            <BannerDesc>
              <b>{t('patients.banner-desc')}</b> {t('patients.banner-desc-two')} <b>{t('patients.banner-desc-three')}</b> {t('patients.banner-desc-four')} <b>{t('patients.banner-desc-five')}</b>
            </BannerDesc>
          </BannerContent>
          <Col
            xs={12}
            md={6}
            id="col-img"
          >
            <img
              alt='persona sonriendo'
              src='https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fbanners%2Fpacientes.png?alt=media&token=58f1bb0b-cbf9-421a-8988-d13d00f7ffa2'
            />
          </Col>
        </Row>
      </Container>
    </BannerBackground>
  );
}